export const applyPenDrawingEffect = async (canvas, ctx, setMessage, language) => {
  // 펜화 효과: 선명한 선과 흑백 대비
  // 1. 그레이스케일 변환
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  for (let i = 0; i < data.length; i += 4) {
    const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 엣지 검출 및 강화
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const edgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const edgePixels = edgeData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // Canny 엣지 검출 시뮬레이션
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 라플라시안 필터
      const laplacian = 
        -1 * tempData[((y - 1) * canvas.width + (x - 1)) * 4] +
        -1 * tempData[((y - 1) * canvas.width + x) * 4] +
        -1 * tempData[((y - 1) * canvas.width + (x + 1)) * 4] +
        -1 * tempData[(y * canvas.width + (x - 1)) * 4] +
         8 * tempData[(y * canvas.width + x) * 4] +
        -1 * tempData[(y * canvas.width + (x + 1)) * 4] +
        -1 * tempData[((y + 1) * canvas.width + (x - 1)) * 4] +
        -1 * tempData[((y + 1) * canvas.width + x) * 4] +
        -1 * tempData[((y + 1) * canvas.width + (x + 1)) * 4];
      
      const edgeStrength = Math.abs(laplacian);
      
      // 엣지가 강한 부분은 검은색으로, 약한 부분은 흰색으로
      const penValue = edgeStrength > 40 ? Math.max(0, 255 - edgeStrength) : 255;
      
      edgePixels[pos] = penValue;
      edgePixels[pos + 1] = penValue;
      edgePixels[pos + 2] = penValue;
    }
  }
  
  ctx.putImageData(edgeData, 0, 0);
  
  // 3. 해칭(Hatching) 효과 시뮬레이션
  const hatchData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const hatchPixels = hatchData.data;
  
  for (let y = 0; y < canvas.height; y += 3) {
    for (let x = 0; x < canvas.width; x += 3) {
      const pos = (y * canvas.width + x) * 4;
      
      if (pos < hatchPixels.length - 4) {
        const brightness = hatchPixels[pos];
        
        // 어두운 부분에 해칭 라인 추가
        if (brightness < 180) {
          // 대각선 해칭 패턴
          if ((x + y) % 6 === 0) {
            for (let i = 0; i < 3 && x + i < canvas.width; i++) {
              const linePos = (y * canvas.width + x + i) * 4;
              if (linePos < hatchPixels.length - 4) {
                hatchPixels[linePos] = Math.max(0, hatchPixels[linePos] - 50);
                hatchPixels[linePos + 1] = Math.max(0, hatchPixels[linePos + 1] - 50);
                hatchPixels[linePos + 2] = Math.max(0, hatchPixels[linePos + 2] - 50);
              }
            }
          }
        }
      }
    }
  }
  
  ctx.putImageData(hatchData, 0, 0);
  
  // 4. 콘트라스트 증가
  const contrastData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const contrastPixels = contrastData.data;
  
  for (let i = 0; i < contrastPixels.length; i += 4) {
    for (let c = 0; c < 3; c++) {
      const value = contrastPixels[i + c];
      contrastPixels[i + c] = value < 128 ? value * 0.7 : Math.min(255, value * 1.3);
    }
  }
  
  ctx.putImageData(contrastData, 0, 0);
};